export enum PaymentStatuses {
	paid = "Оплачен",
	unpaid = "Не оплачен",
}
